import { isEmptyObject } from "../../../utils/tests";
import { LmpMatchStatisticsQuery, LmpMatchStatisticsSubscription  } from '../types';

/**
 * typeguard for LmpMatchStatisticsQuery
 * @param LmpMatchStatisticsQuery object passed to transformer
 */
export const isValidLmpMatchStatisticsQuery = (obj: LmpMatchStatisticsQuery): boolean => Boolean(obj?.data?.getLmpStatistics && !isEmptyObject(obj.data.getLmpStatistics));


/**
 * typeguard for LmpMatchStatisticsSubscription
 * @param LmpMatchStatisticsSubscription object passed to transformer
 */
export const isValidLmpMatchStatisticsSubscription = (obj: LmpMatchStatisticsSubscription): boolean => Boolean(obj?.data?.onUpdateLmpStatisticsByMatchId && !isEmptyObject(obj.data.onUpdateLmpStatisticsByMatchId));

